import Main from '../components/Main';
import Nav from '../components/Nav';
import Aside from '../components/Aside';
import Container from '../components/Container';
import Info from '../components/Info';
import Cardcontainer from '../components/Cardcontainer';
import Card from '../components/Card';
import { toDate } from '../utils/helpers';


const VistaNitro = ({ user, logout, setName, datos, filter, handleShow,appVersion }) => {

  
  
  //----------------------------------------------------------------------------------
  const now = Date.now();
  let less24 = 0;
  let between24and48 = 0;
  let more48 = 0;
  let total = 0;
  datos.data.forEach(d => {
    total++
    if (!d.last_unix) return;
    const diffMs = now - d.last_unix * 1000; // last_unix viene en segundos
    const hours = diffMs / (1000 * 60 * 60);

    if (hours < 24) {
      less24++;
    } else if (hours < 48) {
      between24and48++;
    } else {
      more48++;
    }
  });

  let perc = (less24/total)*100
  perc = Math.round(perc * 10) / 10;   // ej: 23.4

  console.log(
    `Transmiten las ultimas 24h: ${less24}, 24-48h: ${between24and48}, >48h: ${more48}, de un total de${total}`
  );

  //----------------------------------------------------------------------------------







  return (
    <div className="App">
      <Main>
        <Nav user={user} logout={() => logout(false)} cookDestr={logout} appVersion={appVersion}/>
        {/*<Aside change={setName} />*/}
        <Container>
          <Info site="nitro" filter={filter} handleShow={handleShow} 
          kpi={{ less24, between24and48, more48, total, perc }} />

  
          <Cardcontainer>
            {datos.data
              .filter(d => {
                if (filter !== 'ALL') {
                  if (filter === 'EEAA') return ['854K','24M', '988G', '988H', '994F', '777F', '777G', '777', '793F'].includes(d.modelo);
                  if (filter === '777') return ['777F','777', '777G'].includes(d.modelo);
                  if (filter === '988') return ['988G', '988H'].includes(d.modelo);
                  return d.modelo === filter;
                }
                return true;
              })
              .map((d, i) =>
                ['797B_LPP', '797B'].includes(d.modelo) ? (
                  <Card
                    key={`${filter}-${i}`}
                    index={i}
                    firm={d.firm}
                    last_unix={d.last_unix}
                    tkd={d.tkd}
                    kit={d.kit}
                    lpp={d.lpp}
                    dir1={d.dir1}
                    dir2={d.dir2}
                    dir3={d.dir3}
                    fr1={d.f1}
                    fr2={d.f2}
                    date={toDate(d.last_unix)}
                    online={d.online}
                    pm={d.pm}
                    modelo={d.modelo}
                    serie={d.serie}
                  />
                ) : (
                  <Card
                    key={`${filter}-${i}`}
                    index={i}
                    firm={d.firm}
                    last_unix={d.last_unix}
                    tkd={d.tkd}
                    kit={d.kit}
                    lpp={d.lpp}
                    dir1={d.dir1}
                    dir2={d.dir2}
                    dir3={d.dir3}
                    dir4={d.dir4}
                    dir5={d.dir5}
                    dir6={d.dir6}
                    fr1={d.f1}
                    fr2={d.f2}
                    fr3={d.f3}
                    fr4={d.f4}
                    date={toDate(d.last_unix)}
                    online={d.online}
                    pm={d.pm}
                    modelo={d.modelo}
                    serie={d.serie}
                  />
                )
              )}
          </Cardcontainer>
        </Container>
      </Main>
    </div>
  );
};

export default VistaNitro;
